let dogHeader,catHeader,dogDrawer,catDrawer,dogHeaderButtons,catHeaderButtons,dogSideNavMenus,catSideNavMenus,dogSearch,dogLabel,catSearch,catLabel;function init(){window.addEventListener("keypress",(function(e){if("Enter"===e.key){const e=document.querySelector(".clerk-design-component-5Qoku4xm");e&&e.click()}})),dogHeader=document.getElementById("shopify-section-header_dog"),catHeader=document.getElementById("shopify-section-header_cat"),dogDrawer=document.getElementById("Drawer__Dog"),catDrawer=document.getElementById("Drawer__Cat"),dogHeaderButtons=document.querySelectorAll(".Header__Category--dog"),catHeaderButtons=document.querySelectorAll(".Header__Category--cat"),dogSideNavMenus=document.querySelectorAll(".SidebarMenu__Nav--dog"),catSideNavMenus=document.querySelectorAll(".SidebarMenu__Nav--cat"),dogSearch=document.getElementById("search-input-dog-desk"),dogLabel=document.getElementById("search-label-dog-desk"),catSearch=document.getElementById("search-input-cat-desk"),catLabel=document.getElementById("search-label-cat-desk");if(document.querySelectorAll(".click-me").forEach((e=>e.click())),dogSearch.addEventListener("click",openDogSearch),dogLabel.addEventListener("click",openDogSearch),catSearch.addEventListener("click",openCatSearch),catLabel.addEventListener("click",openCatSearch),dogDrawer.addEventListener("click",handleDogDrawerClick),catDrawer.addEventListener("click",handleCatDrawerClick),dogHeaderButtons.forEach((e=>{e.addEventListener("click",(()=>overallCategoryChange("dog")))})),catHeaderButtons.forEach((e=>{e.addEventListener("click",(()=>overallCategoryChange("cat")))})),catHeader.classList.remove("initial-load"),dogHeader.classList.remove("initial-load"),"cat"===window.localStorage.getItem("category"))return catHeader.classList.add("active"),catDrawer.classList.add("active"),void catSideNavMenus.forEach((e=>e.classList.add("active")));dogSideNavMenus.forEach((e=>e.classList.add("active"))),dogHeader.classList.add("active"),dogDrawer.classList.add("active")}function handleDogDrawerClick(){overallCategoryChange("dog"),catSideNavMenus.forEach((e=>e.classList.remove("active"))),catDrawer.classList.remove("active"),dogSideNavMenus.forEach((e=>e.classList.add("active"))),dogDrawer.classList.add("active")}function handleCatDrawerClick(){overallCategoryChange("cat"),dogSideNavMenus.forEach((e=>e.classList.remove("active"))),dogDrawer.classList.remove("active"),catSideNavMenus.forEach((e=>e.classList.add("active"))),catDrawer.classList.add("active")}function overallCategoryChange(e){window.localStorage.setItem("category",e)}function openDogSearch(e){if("search-input"===e.target.className)return document.body.classList.add("lock"),void dogLabel.classList.add("open");document.body.classList.remove("lock"),dogLabel.classList.remove("open")}function openCatSearch(e){if("search-input"===e.target.className)return document.body.classList.add("lock"),void catLabel.classList.add("open");document.body.classList.remove("lock"),catLabel.classList.remove("open")}window.addEventListener("DOMContentLoaded",init);

// let dogHeader, catHeader, dogDrawer, catDrawer, dogHeaderButtons, catHeaderButtons, dogSideNavMenus, catSideNavMenus, dogSearch, dogLabel, catSearch, catLabel;

// function init() {
//     window.addEventListener("keypress", (function (e) {
//         if ("Enter" === e.key) {
//             const searchButton = document.querySelector(".clerk-design-component-5Qoku4xm");
//             searchButton && searchButton.click();
//         }
//     }));

//     dogHeader = document.getElementById("shopify-section-header_dog");
//     catHeader = document.getElementById("shopify-section-header_cat");
//     dogDrawer = document.getElementById("Drawer__Dog");
//     catDrawer = document.getElementById("Drawer__Cat");
//     dogHeaderButtons = document.querySelectorAll(".Header__Category--dog");
//     catHeaderButtons = document.querySelectorAll(".Header__Category--cat");
//     dogSideNavMenus = document.querySelectorAll(".SidebarMenu__Nav--dog");
//     catSideNavMenus = document.querySelectorAll(".SidebarMenu__Nav--cat");
//     dogSearch = document.getElementById("search-input-dog-desk");
//     dogLabel = document.getElementById("search-label-dog-desk");
//     catSearch = document.getElementById("search-input-cat-desk");
//     catLabel = document.getElementById("search-label-cat-desk");

//     // Click elements with class 'click-me'
//     document.querySelectorAll(".click-me").forEach((el) => el.click());

//     // Remove event listeners for search input and labels
//     dogSearch?.removeEventListener("click", openDogSearch);
//     dogLabel?.removeEventListener("click", openDogSearch);
//     catSearch?.removeEventListener("click", openCatSearch);
//     catLabel?.removeEventListener("click", openCatSearch);

//     // Add event listeners for drawers
//     dogDrawer?.addEventListener("click", handleDogDrawerClick);
//     catDrawer?.addEventListener("click", handleCatDrawerClick);

//     // Add event listeners for category buttons
//     dogHeaderButtons.forEach((el) => {
//         el.addEventListener("click", () => overallCategoryChange("dog"));
//     });
//     catHeaderButtons.forEach((el) => {
//         el.addEventListener("click", () => overallCategoryChange("cat"));
//     });

//     // Remove initial load class and apply active class based on stored category
//     catHeader.classList.remove("initial-load");
//     dogHeader.classList.remove("initial-load");

//     if ("cat" === window.localStorage.getItem("category")) {
//         catHeader.classList.add("active");
//         catDrawer.classList.add("active");
//         catSideNavMenus.forEach((el) => el.classList.add("active"));
//     } else {
//         dogHeader.classList.add("active");
//         dogDrawer.classList.add("active");
//         dogSideNavMenus.forEach((el) => el.classList.add("active"));
//     }
// }

// function handleDogDrawerClick() {
//     overallCategoryChange("dog");
//     catSideNavMenus.forEach((el) => el.classList.remove("active"));
//     catDrawer.classList.remove("active");
//     dogSideNavMenus.forEach((el) => el.classList.add("active"));
//     dogDrawer.classList.add("active");
// }

// function handleCatDrawerClick() {
//     overallCategoryChange("cat");
//     dogSideNavMenus.forEach((el) => el.classList.remove("active"));
//     dogDrawer.classList.remove("active");
//     catSideNavMenus.forEach((el) => el.classList.add("active"));
//     catDrawer.classList.add("active");
// }

// function overallCategoryChange(category) {
//     window.localStorage.setItem("category", category);
// }

// window.addEventListener("DOMContentLoaded", init);
